import { createFileRoute } from '@tanstack/react-router'
import PropertiesSettingsPage from '@/pages/settings/properties'

export const Route = createFileRoute(
  '/(protected)/settings/properties'
)({
  component: RouteComponent,
})

function RouteComponent() {
  return <PropertiesSettingsPage />
}